import { type FC } from "react";
import { SelectBox } from "@root/shared/components/SelectBox";
import * as styles from "./styles.css";
import { useDateSelector } from "./useDateSelector";

type DateSelectorProps = {
  options: { label: string; value: number }[];
  value?: number;
  onChange: (value: number) => void;
  hasError?: boolean;
};

type Props = {
  year: DateSelectorProps;
  month: Omit<DateSelectorProps, "options">;
  date: Omit<DateSelectorProps, "options">;
};

export const DateSelector: FC<Props> = ({ year, month, date }) => {
  const { monthOptions, dateOptions } = useDateSelector(year.value, month.value);

  return (
    <div className={styles.wrapper}>
      <SelectBox
        options={year.options}
        placeholder="0000年"
        value={year.value ?? ""}
        onChange={(e) => year.onChange(Number(e.target.value))}
        hasError={year.hasError}
        selected={year.value != null}
        aria-label="年を選択"
        role="combobox"
      />
      <SelectBox
        options={monthOptions}
        placeholder="00月"
        value={month.value ?? ""}
        onChange={(e) => month.onChange(Number(e.target.value))}
        hasError={month.hasError}
        selected={month.value != null}
        aria-label="月を選択"
        role="combobox"
      />
      <SelectBox
        options={dateOptions}
        placeholder="00日"
        value={date.value ?? ""}
        onChange={(e) => date.onChange(Number(e.target.value))}
        hasError={date.hasError}
        selected={date.value != null}
        aria-label="日を選択"
        role="combobox"
      />
    </div>
  );
};
